import { CONST_ROWS_PER_PAGE } from '@commons/consts';

import {
  NEW_FILTER_USUARIO_PRODUTOR_PENDING,
  NEW_FILTER_USUARIO_PRODUTOR_SUCCESS,
  NEW_FILTER_USUARIO_PRODUTOR_FAILURE,
  NEW_FILTER_NEXT_PAGE_USUARIO_PRODUTOR_PENDING,
  NEW_FILTER_NEXT_PAGE_USUARIO_PRODUTOR_SUCCESS,
  NEW_FILTER_NEXT_PAGE_USUARIO_PRODUTOR_FAILURE,
  FIND_USUARIO_PRODUTOR_DETAILS_PENDING,
  FIND_USUARIO_PRODUTOR_DETAILS_SUCCESS,
  FIND_USUARIO_PRODUTOR_DETAILS_FAILURE,
} from './actionTypes';

const initialState = {
  list: null,
  loading: false,
  filter: { rows: CONST_ROWS_PER_PAGE, page: 0, where: '' },
};

function usuarioProdutorReducer(state = initialState, action) {
  switch (action.type) {
    case FIND_USUARIO_PRODUTOR_DETAILS_PENDING:
    case NEW_FILTER_USUARIO_PRODUTOR_PENDING:
    case NEW_FILTER_NEXT_PAGE_USUARIO_PRODUTOR_PENDING:
      return {
        ...state,
        loading: true,
      };
    // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
    case FIND_USUARIO_PRODUTOR_DETAILS_SUCCESS:
      return {
        ...state,
        registro: action.usuarioDetails,
        usuarioDetails: action.usuarioDetails,
        loading: false,
      };
    case FIND_USUARIO_PRODUTOR_DETAILS_FAILURE:
      return {
        ...state,
        registro: null,
        usuarioDetails: null,
        loading: false,
      };
    // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
    case NEW_FILTER_USUARIO_PRODUTOR_SUCCESS: {
      return {
        ...state,
        list: action.list,
        filter: action.filter,
        loading: false,
      };
    }
    case NEW_FILTER_USUARIO_PRODUTOR_FAILURE: {
      return {
        ...state,
        loading: false,
      };
    }
    // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
    case NEW_FILTER_NEXT_PAGE_USUARIO_PRODUTOR_SUCCESS:
      return {
        ...state,
        list: action.list,
        filter: action.filter,
        loading: false,
      };
    case NEW_FILTER_NEXT_PAGE_USUARIO_PRODUTOR_FAILURE:
      return {
        ...state,
        list: null,
        loading: false,
      };
    // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
    default:
      return state;
  }
}

export { usuarioProdutorReducer };
